import { render, staticRenderFns } from "./LinkProductPermission.vue?vue&type=template&id=523fbd48"
import script from "./LinkProductPermission.vue?vue&type=script&lang=js"
export * from "./LinkProductPermission.vue?vue&type=script&lang=js"
import style0 from "./LinkProductPermission.vue?vue&type=style&index=0&id=523fbd48&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports